export enum INVESTOR_SIGN_UP_STEPS {
  OBJECTIVE = 'OBJECTIVE',
  START = 'START',
  ADDRESS = 'ADDRESS',
  DOCS = 'DOCS',
  FINISH = 'FINISH',
}
